import { required, shape, fromModel, email, when } from '@totalsoft/pure-validations';

export const userGroupValidator = fromModel(model =>
  shape({
    name: required,
    code: required,
    email: email |> when(Boolean(model.email))
  })
);

export const userXGroupValidator = shape({
  userId: required
});
